import { animateScroll as scroll } from 'react-scroll';
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';

export const extendMouseEventForSafari = () => {
  if (!('path' in Event.prototype)) {
    Object.defineProperty(Event.prototype, 'path', {
      get: function () {
        const path = [];
        let currentElem = this.target;
        while (currentElem) {
          path.push(currentElem);
          currentElem = currentElem.parentElement;
        }
        if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
          path.push(document);
        if (path.indexOf(window) === -1)
          path.push(window);
        return path;
      }
    });
  }
}

export const addSVGClass = (el, className) => {
  const classes = el.className.baseVal.split(' ');
  if ( classes.find( c => c === className) === undefined ) {
    el.className.baseVal += ' ' + className;
  }
}

export const removeSVGClass = (el, className) => {
  el.className.baseVal = el.className.baseVal.replace(className, '');
}

export function shareToFB(extra) {
  if(extra === undefined) {
      extra = ''
  }
  window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(window.location.href)));
}

export function shareToLine() {
  var link = "http://line.naver.jp/R/msg/text/?openExternalBrowser=1";
  link += "" + "%0D%0A" + encodeURIComponent(window.location.href);
  window.open(link);
  return false;
}

export function shareToTwitter() {
  var content = "";
  var locate = encodeURIComponent(window.location.href);
  var link = "https://twitter.com/intent/tweet?text=" + content + "&url=" + locate;
  window.open(link);
  return false;
}

export function copyLink(e, onComplete = null) {
  copyToClipboard(window.location.href);
  onComplete && onComplete();
}

function copyToClipboard(text) {
  var temp = document.createElement("input");
  $("body").append(temp);
  temp.value = text;
  temp.select();
  document.execCommand("copy");
  temp.remove();
}

export const scrollToTop = (smooth = false, sec = 700) => {
  let options = { smooth: smooth, duration: smooth ? sec : 0 };
  scroll.scrollTo(0, options);
}

export const useApiToGetItemsAndCategories = (api_url, onError = null) => {

  const [list, setList] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(api_url)
    .then( res => {
      setList(res.data.items);
      setCategories(res.data.categories);
    })
    .catch(onError);
  }, [])

  return [list, categories];
}


export const useScroll = (callback) => {
  const el = useRef(null);

  useEffect(() => {
    const scrollDom = document.querySelector('#content-frame');
    const scrollDomHeight = scrollDom.clientHeight;
    const elHeight = el.current.clientHeight;
    const allHeight = scrollDomHeight + elHeight;

    const handleScroll = e => {
      const { top } = el.current.getBoundingClientRect();
      const calcedTop = top + elHeight;
      if (calcedTop > 0 && calcedTop < allHeight) {
        const prog = 1 - calcedTop / allHeight;
        callback(prog);
      }
    }

    scrollDom.addEventListener('scroll', handleScroll)
    return () => {
      scrollDom.removeEventListener('scroll', handleScroll)
    }
  }, []);

  return el;
}

export const vhFix = () => {

  const injectVhToDocument = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  window.addEventListener('resize', () => {
    injectVhToDocument();
  });
  injectVhToDocument();
}

export const zeroTransfer = (num) => {
  let str = num + "";
  if (str.length === 1) {
    str = "0" + str
  }
  return str
}

export const getOffsetTop = element => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

export const getData = (slug) => {
  let lang = window.location.pathname.split('/')[1];
  if ( !['en', 'zh-TW'].find( _ => _ === lang) ) {
    lang = 'zh-TW';
  }
  return new Promise((resolve, reject) => {
    axios.get(`/api/${slug}`,
    { 'headers': { 'X-localization': lang } })
    .then(
      (res) => {
        resolve(res.data);
      }
    )
    .catch((err) => {
      reject(err)
    })
  })
}

export const setScrollTrigger = () => {
  const triggers = document.querySelectorAll('.scroll-trigger');
  triggers.forEach(trigger => {
    const offsetTop = trigger.getBoundingClientRect().top - window.innerHeight * 0.75;
    const triggerClassList = trigger.classList;
    if (offsetTop < 0 && triggerClassList.contains('-active') === false) {
      triggerClassList.add('-active');
    }
  })
}

export const getUrl = (lastPathname, slug) => {
  if (lastPathname === null) {
    const pathname = window.location.pathname.split('/');
    if (pathname[1] === 'en' || pathname[1] === 'zh-TW') {
      const result = pathname.slice(0, 2).join('/');
      return `${result}/${slug}`;
    }
    else {
      const result = pathname.slice(0, 1).join('/');
      return`${result}/${slug}`;
    }

  }
  else {
    const pathname = window.location.pathname.split('/');
    const index = pathname.indexOf(lastPathname);
    const result = pathname.slice(0, index + 1).join('/');

    return `${result}/${slug}`
  }
}

export const rebuildInfoData = (infos) => {
  if (infos !== '') {
    const infosTitle = [];
    const infosContent = JSON.parse(infos);
    infosContent.forEach(info => {
      if (infosTitle.indexOf(info.title) === -1) {
        infosTitle.push(info.title);
      }
    });
    const infosData = infosTitle.map(title => {
      return { title: title, content: [] };
    });
    infosTitle.map((title, i) => {
      infosContent.forEach(info => {
        if (title === info.title) {
          infosData[i].content.push(info.content)
        }
      })
    });
    return infosData
  }
  else {
    return null
  }
}

export const dateFormat = (date, type='YYYY/MM/DD') => {
  return dayjs(date).format(type);
};


export const getFirstPhoto = (item) => {
  if (typeof item === 'string') {
    return JSON.parse(item)[0];
  }
  else {
    return item[0];
  }
}

export const lockWindow = (status) => {
  if (status) {
    document.body.style.overflow = 'hidden';
  }
  else {
    document.body.style = {};
  }
}


export const getSlugByPathname = str => {
  const pathname = window.location.pathname.split('/');
  const index = pathname.findIndex(item => item === str);
  if (index) {
    return pathname[index + 1];
  }
  else {
    return undefined;
  }
}